import {BaseCriteriaModel} from '../base-criteria.model';
import {Optional} from 'typescript-optional';

export class ChartOfAccGLCodeLinkQueryCriteriaClass extends BaseCriteriaModel {
  gl_code_1?: Optional<string> = Optional.empty();
  gl_code_2?: Optional<string> = Optional.empty();
  gl_code_3?: Optional<string> = Optional.empty();
  gl_code_4?: Optional<string> = Optional.empty();
  gl_code_name?: Optional<string> = Optional.empty();
  link_type?: Optional<string> = Optional.empty();
  description?: Optional<string> = Optional.empty();

  guids?: Optional<string> = Optional.empty();
  chart_of_acc_guids?: Optional<string> = Optional.empty();
  glcode_guids?: Optional<string> = Optional.empty();
}

export class ChartOfAccGLCodeLinkCriteriaModelQuery {
  query = '';

  constructor(chartOfAccGLCodeLinkCriteriaModel: ChartOfAccGLCodeLinkQueryCriteriaClass) {

    if (!chartOfAccGLCodeLinkCriteriaModel) {
      return;
    }

    this.query += chartOfAccGLCodeLinkCriteriaModel.gl_code_1.filter(x => x !== '').map(x => '&gl_code_1=' + x).orElse('');
    this.query += chartOfAccGLCodeLinkCriteriaModel.gl_code_2.filter(x => x !== '').map(x => '&gl_code_2=' + x).orElse('');
    this.query += chartOfAccGLCodeLinkCriteriaModel.gl_code_3.filter(x => x !== '').map(x => '&gl_code_3=' + x).orElse('');
    this.query += chartOfAccGLCodeLinkCriteriaModel.gl_code_4.filter(x => x !== '').map(x => '&gl_code_4=' + x).orElse('');
    this.query += chartOfAccGLCodeLinkCriteriaModel.gl_code_name.filter(x => x !== '').map(x => '&gl_code_name=' + x).orElse('');
    this.query += chartOfAccGLCodeLinkCriteriaModel.link_type.filter(x => x !== '').map(x => '&link_type=' + x).orElse('');
    this.query += chartOfAccGLCodeLinkCriteriaModel.description.filter(x => x !== '').map(x => '&description=' + x).orElse('');

    this.query += chartOfAccGLCodeLinkCriteriaModel.guids.filter(x => x !== '').map(x => '&guids=' + x).orElse('');
    this.query += chartOfAccGLCodeLinkCriteriaModel.chart_of_acc_guids.filter(x => x !== '').map(x => '&chart_of_acc_guids=' + x).orElse('');
    this.query += chartOfAccGLCodeLinkCriteriaModel.glcode_guids.filter(x => x !== '').map(x => '&glcode_guids=' + x).orElse('');

    this.query += '&status=' + chartOfAccGLCodeLinkCriteriaModel.status;
    this.query += '&orderBy=' + chartOfAccGLCodeLinkCriteriaModel.orderBy;
    this.query += '&order=' + chartOfAccGLCodeLinkCriteriaModel.order;
    this.query += '&offset=' + chartOfAccGLCodeLinkCriteriaModel.offset + '&limit=' + chartOfAccGLCodeLinkCriteriaModel.limit;
  }
}
